import React from "react"
import { useTranslation } from "react-i18next"
import { useLoggedInEmployeeProfile } from "~Shared/queries/employee.queries"
import { PurchaseOrder } from "../types/PurchaseOrder.interfaces"
import { PurchaseOrderActionButton } from "./PurchaseOrderActionButton"
import { getStateConfig } from "./PurchaseOrderActionButtons"

export const PurchaseOrderTodoApprovalButtons = ({ record }: { record: PurchaseOrder }) => {
    const user = useLoggedInEmployeeProfile()
    const { t } = useTranslation()
    if (!user) {
        return null
    }
    const config = getStateConfig({ purchaseOrder: record, user, t })
    return config?.buttons
        .slice(0, 2)
        .map((button, index) => <PurchaseOrderActionButton className="btn-default min-w-120 mr-10" key={index} {...button} purchaseOrderId={record._id} />)
}
